export default __webpack_public_path__ + "static/media/IMG_5510 copie.0b37d471.jpg";